import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pagination } from '@common/const/search-filter.constants';
import { UserProfile } from '@common/model/user-profile.model';
import { ReadService } from '@common/service/read.service';
import { AuthService } from '@core/auth/auth.service';
import { EntityResponseType } from '@core/service/generic.service';
import { environment } from '@environments/environment';
import { BehaviorSubject, interval, Observable, Subscription, tap, throwError } from 'rxjs';
import { catchError, takeWhile } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NotificationPollingService {
  private notifications$ = new BehaviorSubject<any[]>([]);
  private userInfo$ = new BehaviorSubject<UserProfile | undefined>(undefined);

  protected resourceUrl = `${environment.SERVER_NOTIFICATION_API_URL}/api/notifications`;

  private pollingSub?: Subscription;
  page = Pagination.PageStart;
  pageSize = Pagination.PageSize;
  totalCount = 0;

  constructor(
    private readService: ReadService,
    protected http: HttpClient,
    private authService: AuthService
  ) {
    // Charger le profil utilisateur au démarrage
    this.authService.getProfile().subscribe({
      next: (profile) => {
        this.userInfo$.next(profile);
        this.startPolling();
      },
      error: (err) => {
        console.error('Erreur lors du chargement du profil utilisateur', err);
        // this.startPolling(); // On démarre quand même le polling, mais sans userInfo
      },
    });
  }

  post(element: any): Observable<HttpResponse<any>> {
    // Utilise l'API de notification pour créer une notification
    return this.http.post<any>(this.resourceUrl, element, {
      observe: 'response',
    });
  }

  getNotifications(): Observable<any[]> {
    return this.notifications$.asObservable();
  }

  private startPolling(): void {
    this.loadNotifications();
    this.pollingSub = interval(120000).pipe(takeWhile(() => this.authService.isAuthenticated())).subscribe(() => this.loadNotifications());
  }

  /* ngOnDestroy(): void {
    if (this.pollingSub) {
      this.pollingSub.unsubscribe();
    }
  }*/

  private loadNotifications(): void {
    const userInfo = this.userInfo$.getValue();
    const roles = userInfo?.roles ?? [];
    const utilisateurId = userInfo?.id ?? null;
    console.log('userInfo roles (backend)', roles);

    if (!roles.length || utilisateurId == null) {
      console.warn('Polling notifications annulé : roles vide ou utilisateurId nul');
      this.notifications$.next([]);
      this.totalCount = 0;
      return;
    }

    this.readService
      .queryPaged('listNotificationsUtilisateur', {
        params: {
          roles: roles,
          utilisateurId: utilisateurId,
        },
        page: {
          page: this.page - 1,
          size: this.pageSize,
        },
      })
      .subscribe({
        next: (result) => {
          const records = result?.records ?? [];
          console.log('Notifications chargées :', records);
          this.totalCount = result?.totalCount ?? 0;
          this.notifications$.next(records);
        },
        error: (err) => console.error('Erreur de polling notifications', err),
      });
  }

  update(element: any): Observable<EntityResponseType> {
    return this.http
      .patch<any>(`${this.resourceUrl}/${element.id}`, element, {
        observe: 'response',
      })
      .pipe(
        tap(() => this.loadNotifications()),
        catchError((error) => {
          console.error('Erreur lors de la mise à jour :', error);
          return throwError(() => error); // Propager l'erreur
        })
      );
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}/${id}`, { observe: 'response' }).pipe(
      tap(() => this.loadNotifications()),
      catchError((error) => {
        console.error('Erreur lors de la suppression :', error);
        return throwError(() => error); // Propager l'erreur
      })
    );
  }
}
